import React, { Component } from "react";
// import { API_URL } from "../../Config";
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  MenuItem,
  Icon
} from "@material-ui/core";
// import { Link } from "react-router-dom";
import SnackBarComponent from "../../SnackBar/SnackBar";
import InputAdornment from "@material-ui/core/InputAdornment";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import ReactTableComponent from "../../ReactTable/ReactTable";
import { userList } from "./UserConfig";
import {
  getAllSites,
  getUserData,
  saveUserdata,
  allUserSiteMap,
} from "./UserQueries";
import { fetchMethod } from "../../FetchMethod";
import { connect } from "react-redux";
import "./users.css";
import store from "../../Redux/Store";
import { mutationQueries } from "../../MutationMethod";
import { FadeLoader } from "react-spinners";
import Autocomplete from "@material-ui/lab/Autocomplete";

const iconComponent = (props) => {
  return (
    <Icon className={props.className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.992"
        height="8"
        viewBox="0 0 13.992 8"
        style={{
          fill: "#69BAFE",
          // width: "23px",
          height: "auto",
        }}
      >
        <defs></defs>
        <path
          className="a"
          d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
          transform="translate(-6.188 -11.246)"
        />
      </svg>
    </Icon>
  );
};

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: parseInt(localStorage.getItem("rows")),
      rows: parseInt(localStorage.getItem("rows")),
      listData: [],
      isAscSort: true,
      RoleData: [
        { id: "", name: "" },
        { id: "ADMIN", name: "Administrator" },
        { id: "ASSISTANT", name: "Assistant" },
        { id: "PHYSICIAN", name: "Physician" },
        { id: "SALESREP", name: "Sales Representative" },
      ],
      siteData: [],
      allSiteData: [],
      filter: { active: 1, order: "createdon DESC" },
      sitefilter: { active: 1 },
      countryData: undefined,
      cityData: undefined,
      salesRepData: undefined,
      deletemodalOpen: false,
      role: "",
      site: "",
      search: "",
      isRolePermission: store.getState().Permission
        ? store.getState().Permission.USER_SITE_FILE_PERMISSION
        : false,
      loading: true,
      open: false,
      severity: "",
      alertmsg: "",
    };
  }
  componentDidMount() {
    this.setState({ listData: [] });
    this.props.sideBarPath("/users");
    this.getListData();
    this.getAllSites();
  }
  siteName = (items) => {
    let site = "",
      sitefulllist = "";
    let count = 0;
    if (items.mappedUser.Usersitemaps.length) {
      items.mappedUser.Usersitemaps.map((mappedItems, index) => {
        sitefulllist += `${
          sitefulllist && items.mappedUser.Usersitemaps.length - 1 === index
            ? ""
            : ""
        } ${
          mappedItems.mappedsiterel.Sites.length
            ? mappedItems.mappedsiterel.Sites[0].name +','
            : ""
        }`;
        count += mappedItems.mappedsiterel.Sites.length
          ? mappedItems.mappedsiterel.Sites[0].name
            ? 1
            : 0
          : 0;
        site = site
          ? site
          : mappedItems.mappedsiterel.Sites.length
          ? mappedItems.mappedsiterel.Sites[0].name
          : "";
      });
      sitefulllist=sitefulllist.slice(0, -1)
      return { site, sitefulllist, count: count ? count - 1 : count };
    }
    return { site, sitefulllist, count };
  };

  LinkClicked = (e, data) => {
    const { id } = e.target;
    let { listData } = this.state;
    listData.map((useritems) => {
      if (useritems.id === data.id) {
        useritems.sites = useritems.sitefulllist;
        useritems.siteclicked = true;
        return useritems;
      }
    });
    this.setState({ listData });
  };
  getListData = () => {
    this.setState({ loading: true, listData: [] });
    fetchMethod(getUserData, {
      where: this.state.filter,
      last: this.state.rows,
      first: this.state.pageNo,
      sitewhere: this.state.sitefilter,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.data.allUserdata) {
          this.setState({
            listData: res.data.allUserdata.Userdata.map((items, index) => {
              let role = "";
              switch (items.role) {
                case "ADMIN":
                  role = "Administrator";
                  break;
                case "PHYSICIAN":
                  role = "Physician";
                  break;
                case "ASSISTANT":
                  role = "Assistant";
                  break;
                case "SALESREP":
                  role = "Sales Representative";
                  break;
                default:
                  role = "";
              }
              // let count = 0;
              let { site, sitefulllist, count } = this.siteName(items);
              // count =
              //   this.state.indexRow !== index
              //     ? items.mappedUser.Usersitemaps.length && site
              //       ? items.mappedUser.Usersitemaps.length - 1
              //       : 0
              //     : 0;
              Object.assign(items, {
                name:
                  `${items.firstname}` +
                  `${items.lastname === null ? "" : " " + items.lastname}`,
                role: role,
                sites: site,
                sitefulllist,
                sitecount: count,
                LinkClicked: this.LinkClicked,
              });
              return items;
            }),
            count: res.data.allUserdata.totalCount,
            loading: false,
            clicked: false,
          });
        } else {
          this.setState({ loading: false, clicked: false });
        }
      })
      .catch((e) => {
        this.setState({ loading: false, clicked: false });
        console.log(e);
      });
  };
  getAllSites=()=>{
    fetchMethod(getAllSites, {
      // where: this.state.autositefilter,
      where: {active:1},
    })
    .then((res) => res.json())
    .then(res=>{
      if (res.error && res.error.statusCode === 401) {
        localStorage.clear();
        window.location = "/";
      }
      let siteData = res.data.allSites ? res.data.allSites.Sites : [];
      this.setState({
        siteData: siteData,
        allSiteData:siteData
      });
    })
  }
  getSites = () => {
    let { sitefilter, filter } = this.state;
        let {siteData} = this.state;
        let siteobj = siteData.filter((item) => item.name === this.state.site)
          .length
          ? siteData.filter((item) => item.name === this.state.site)[0]
          : null;
        if (siteobj) {
          sitefilter["siteId"] = siteobj.id;
          fetchMethod(allUserSiteMap, { where: sitefilter })
            .then((res) => res.json())
            .then((res) => {
              if (res.data.allUsersitemaps.Usersitemaps.length) {
                let queryValue = res.data.allUsersitemaps.Usersitemaps.map(
                  (item) => {
                    return { id: item.userid };
                  }
                );
                filter["and"] = [
                  {
                    or: queryValue,
                  },
                ];
                this.setState(
                  { sitefilter, filter, pageNo: this.state.rows },
                  () => this.getListData()
                );
              } else {
                this.setState({
                  listData: [],
                });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
  };
  updatePagination = (pageNumber, size) => {
    this.setState(
      {
        pageNo: pageNumber,
        rows: size,
      },
      () => {
        this.getListData();
      }
    );
  };
  adduser = () => {
    this.props.history.push("/add-user");
  };
  handleClose = (id) => {
    this.setState((prevState) => {
      return { deletemodalOpen: !prevState.deletemodalOpen, deleteid: id };
    });
  };
  handleDelete = (e) => {
    const variable = {
      id: this.state.deleteid,
      active: 0,
    };
    this.setState({ loading: true });
    mutationQueries(saveUserdata, { obj: variable })
      .then((res) => {
        this.setState({ loading: false });
        const id = res.data.saveUserdata.id;
        if (id) {
          let pageNo = this.state.pageNo;
          let previousData = this.state.listData.length;
          this.setState({
            listData: [],
            open: true,
            severity: "success",
            alertmsg: "User deleted successfully",
          });

          const { filter } = this.state;

          let search = this.state.search;
          let role = this.state.role;

          if (
            this.state.search !== "" &&
            this.state.role !== "" &&
            previousData === 1
          ) {
            pageNo = this.state.rows;
            delete filter["and"];
            search = "";
            role = "";
          } else if (
            this.state.search === "" &&
            previousData === 1 &&
            pageNo !== this.state.rows
          ) {
            pageNo = this.state.pageNo - this.state.rows;
          } else {
            pageNo = this.state.pageNo;
          }

          this.setState(
            {
              pageNo,
              filter,
              search,
              role,
              deletemodalOpen: false,
              deleteid: 0,
            },
            () => this.getListData()
          );
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
          severity: "error",
          alertmsg: e.message,
        });
        console.log(e);
      });
  };
  handleSearch = (event) => {
    const { filter } = this.state;
    filter["and"] = [
      {
        or: [
          { firstname: { like: `%${event.target.value}%` } },
          { lastname: { like: `%${event.target.value}%` } },
          { email: { like: `%${event.target.value}%` } },
        ],
      },
    ];
    this.setState(
      { filter, search: event.target.value, pageNo: this.state.rows },
      () => this.getListData()
    );
  };
  handleSelectChange = (e,name) => {
    let { value } = e.target;
    const { filter } = this.state;
    this.setState({ [name]: value });
    // filter["and"] = [
    //   {
    //     or: [{ [id]: { like: `%${value}%` } }],
    //   },
    // ];
    filter[name] = value;
    this.setState({ filter, pageNo: this.state.rows }, () =>
      this.getListData()
    );
  };
  refresh = (e) => {
    this.setState(
      {
        role: "",
        site: "",
        search: "",
        filter: { active: 1, order: "createdon DESC" },
        siteData:this.state.allSiteData
      },
      () => this.getListData()
    );
  };
  editForm = (id) => {
    this.props.history.push({ pathname: "edit-user", state: { id: id } });
  };

  sortByHeader = (item) => {
    if (item === "name") {
      const { filter } = this.state;
      let { sortingParam, isAscSort } = this.state;

      if (this.state.isAscSort) {
        filter["order"] = "firstname DESC";
        sortingParam = "firstname";
        isAscSort = false;
      } else {
        sortingParam = item;
        filter["order"] = "firstname ASC";
        isAscSort = true;
      }

      this.setState(
        {
          filter,
          sortingParam,
          isAscSort,
        },
        () => this.getListData()
      );
    }
  };
  handleSnackBarClose = () => {
    this.setState({ open: false, severity: "", alertmsg: "" });
  };
  handleSearchSelect = (e, value) => {
    let {allSiteData,siteData,filter}=this.state
    if (value) {
      let { autositefilter } = this.state;
      let PATTERN = RegExp(value?value:'','i');
      siteData=allSiteData.filter(items=>PATTERN.test(items.name))
      autositefilter = { name: { like: `%${value}%` }, active: 1 };
      this.setState({ site: value, autositefilter,siteData }
        , () => {
        return this.state.site.length >= 2 ? this.getSites(): "";
      }
      );
    } else {
      filter && filter.and && delete filter.and
      this.setState({ site: value, pageNo: this.state.rows ,siteData:allSiteData , filter});
      this.getListData();
    }
  };
  render() {
    const nameAndImage = [
      {
        Header: () => {
          return (
            <div style={{ cursor: "pointer" }}>
              Name &nbsp;
              {this.state.isAscSort ? <ArrowUpward /> : <ArrowDownward />}
            </div>
          );
        },
        accessor: "name",
      },
    ];
    const actions = [
      {
        Header: "Action",
        sortable: false,
        visible: true,
        Cell: (row) => (
          <div>
            <IconButton
              className="editIcon"
              onClick={(e) => this.editForm(row.original.id)}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              className="closeIcon"
              onClick={(e) => this.handleClose(row.original.id)}
            >
              <DeleteRoundedIcon />
            </IconButton>
          </div>
        ),
      },
    ];
    const columns = this.state.isRolePermission
      ? nameAndImage.concat(userList.columns).concat(actions)
      : nameAndImage.concat(userList.columns);
    return (
      <div className="userSection">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <h4>Users</h4>
        <div className="userSearchSection">
          {/* <TextField variant="outlined" /> */}
          <TextField
            id="searchField"
            label="Search"
            autoComplete="off"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className="searchIcon" />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            placeholder="By Name"
            className="searchField"
            onChange={this.handleSearch}
            value={this.state.search}
          />
          <Autocomplete
            freeSolo
            id="controllable-states-demo"
            name="site"
            // className="selectFields siteStatus"
            getOptionLabel={(option) => (option.name ? option.name : "")}
            inputValue={this.state.site}
            onInputChange={this.handleSearchSelect}
            options={this.state.siteData}
            variant="outlined"
            disableClearable
            forcePopupIcon={true}
            popupIcon={<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.992"
                  height="8"
                  viewBox="0 0 13.992 8"
                  style={{ fill: "#69BAFE", marginRight: "5px" }}
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                    transform="translate(-6.188 -11.246)"
                  />
                </svg>}
            renderInput={(params) => (
              <TextField
                {...params}
                className="siteStatus"
                label="Site"
                variant="outlined"
              />
            )}
          />
          <TextField
            className="siteStatusField selectFields"
            labelid="demo-simple-select-outlined-label"
            id="role"
            variant="outlined"
            select
            value={this.state.role}
            onChange={(e)=>this.handleSelectChange(e,'role')}
            label="Role"
            name="UserRole"
            SelectProps={{
              IconComponent: iconComponent,
            }}
          >
            {this.state.RoleData.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id} id="role">
                  {item.name}
                </MenuItem>
              );
            })}
          </TextField>
          {this.state.search || this.state.role || this.state.site ? (
            <Button
              variant="outlined"
              className="resetbtn"
              onClick={this.refresh}
            >
              Reset
            </Button>
          ) : (
            ""
          )}
          {this.state.isRolePermission ? (
            <div className="add-btn">
              <Button
                variant="outlined"
                className="adduserbtn"
                onClick={this.adduser}
              >
                Add User
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
        {/* Table structure */}
        <div className="UsersTableSection">
          <ReactTableComponent
            listData={this.state.listData}
            listConfig={userList}
            columns={columns}
            dataCount={this.state.count}
            onHeaderClick={this.sortByHeader}
            updatePagination={this.updatePagination}
            initialPage={this.state.pageNo / this.state.rows}
            forSerialNo={{
              pageNo: this.state.pageNo,
              pageSize: this.state.rows,
            }}
          />
        </div>
        <Dialog
          open={this.state.deletemodalOpen}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} className="cancelbtn">
              Cancel
            </Button>
            <Button
              onClick={this.handleDelete}
              autoFocus
              className="confirmbtn"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    sideBarPath: (route) =>
      dispatch({ type: "Show_Sidebar_Route", payload: route }),
    addRole: (route) => {
      dispatch({ type: "Role", payload: route });
    },
  };
};

export default connect(null, mapDispatchToProps)(Users);
